import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchVesselById = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchVesselById = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    if (!vesselId) {
      throw new Error("Vessel ID is required");
    }

    const endpoint = `${process.env.REACT_APP_SERVER_URL}/vessel/${vesselId}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.message || "Failed to fetch vessel details");
    }

    return responseData;
  };

  const {
    data: vesselData,
    error: vesselError,
    isLoading: vesselLoading,
    refetch: refetchVessel,
  } = useQuery(
    ["fetchVesselById", vesselId],
    fetchVesselById,
    {
      enabled: !!token && !!vesselId,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  return {
    vessel: vesselData?.data || null,
    vesselError,
    vesselLoading,
    refetchVessel,
  };
};

export default useFetchVesselById; 